import React, { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Link as MuiLink,
  IconButton,
} from "@mui/material";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const [popupVisible, setPopupVisible] = useState(false);

  const closePopup = useCallback(() => {
    setPopupVisible(false);
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        color: "rgba(255,255,255,1)",
        p: 4,
        backgroundColor: "rgba(35, 65, 82, 1)",
      }}
    >
      <Grid container spacing={4}>
        {/* Company Information */}
        <Grid item xs={12} md={3}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <img src="logo22.png" alt="Logo" height="40px" width="40px" />
            <Typography
              variant="h6"
              sx={{ ml: 1, color: "white", fontWeight: 600, fontSize: "1.18rem" }}
            >
              Matt Scholar Solutions
            </Typography>
          </Box>
          {/* Head Office */}
          <Typography
            variant="subtitle1"
            color="rgb(29,35,42)"
            gutterBottom
            sx={{
              fontWeight: "bold",
              background:
                "linear-gradient(-98deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 0%) 50%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 0%)",
              borderLeft: "5px solid orange",
              fontSize: "1rem",
            }}
          >
            Head Office
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
            3rd floor, Pillars Gate,
            <br />
            Vadasery, Kanyakumari Dist,
            <br />
            Tamil Nadu 629001
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, fontSize: "0.75rem" }}>
            Phone:{" "}
            <MuiLink href="tel:+917305197833" color="inherit" underline="none">
              +91 73051 97833
            </MuiLink>{" "}
            &amp;{" "}
            <MuiLink href="tel:+918547486582" color="inherit" underline="none">
              +91 85474 86582
            </MuiLink>
          </Typography>

          {/* Branch Office */}
          <Typography
            variant="subtitle1"
            color="rgb(29,35,42)"
            gutterBottom
            sx={{
              mt: 3,
              fontWeight: "bold",
              background:
                "linear-gradient(-98deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 0%) 50%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 0%)",
              borderLeft: "5px solid orange",
              fontSize: "1rem",
            }}
          >
            Branch Office
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
            1st Floor, Quality Bakers,
            <br />
            HMT Junction, Kalamassery,
            <br />
            Ernakulam-683104
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, fontSize: "0.75rem" }}>
            Phone:{" "}
            <MuiLink href="tel:+917305197833" color="inherit" underline="none">
              +91 73051 97833
            </MuiLink>
          </Typography>
        </Grid>

        {/* Main Services NavLinks */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="subtitle1"
            color="rgb(29,35,42)"
            gutterBottom
            sx={{
              marginBottom: "10px",
              fontWeight: "bold",
              background:
                "linear-gradient(-98deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 0%) 50%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 0%)",
              borderLeft: "5px solid orange",
              fontSize: "1rem",
            }}
          >
            Main Services
          </Typography>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              fontSize: "0.875rem",
              fontWeight: "300",
              color: "white",
            }}
          >
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/dissertation-writing-services")}
                color="inherit"
                underline="none"
              >
                Dissertation
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/coursework-writing")}
                color="inherit"
                underline="none"
              >
                Coursework
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/literature-review-writing")}
                color="inherit"
                underline="none"
              >
                Literature Review
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/research-methodology-services")}
                color="inherit"
                underline="none"
              >
                Research Methodology
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/data-analysis-services")}
                color="inherit"
                underline="none"
              >
                Data Analysis
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/manuscript-preparation")}
                color="inherit"
                underline="none"
              >
                Manuscript
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/project-report-writing")}
                color="inherit"
                underline="none"
              >
                Project writing services
              </MuiLink>
            </li>

            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/publication-services")}
                color="inherit"
                underline="none"
              >
                Publication
              </MuiLink>
            </li>
          </ul>
        </Grid>

        {/* Quick Links and Links Section NavLinks */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="subtitle1"
            color="rgb(29,35,42)"
            gutterBottom
            sx={{
              marginBottom: "10px",
              fontWeight: "bold",
              background:
                "linear-gradient(-98deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 0%) 50%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 0%)",
              borderLeft: "5px solid orange",
              fontSize: "1rem",
            }}
          >
            Quick Links
          </Typography>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              fontSize: "0.875rem",
              fontWeight: "300",
            }}
          >
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/about")}
                color="inherit"
                underline="none"
              >
                About Us
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/privacy-policy")}
                color="inherit"
                underline="none"
              >
                Privacy policy
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/terms-and-conditions")}
                color="inherit"
                underline="none"
              >
                Terms & conditions
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/dissertation-writing-services")}
                color="inherit"
                underline="none"
              >
                Services
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href=""
                onClick={() => navigate("/contact-us")}
                color="inherit"
                underline="none"
              >
                Contact Us
              </MuiLink>
            </li>
          </ul>
        </Grid>

        {/* Social Media Links */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="subtitle1"
            color="rgb(29,35,42)"
            gutterBottom
            sx={{
              marginBottom: "10px",
              fontWeight: "bold",
              background:
                "linear-gradient(-98deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 0%) 50%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 0%)",
              borderLeft: "5px solid orange",
              fontSize: "1rem",
            }}
          >
            Social
          </Typography>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              fontSize: "0.875rem",
              fontWeight: "300",
            }}
          >
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href="https://facebook.com/mattenggsolutions"
                target="_blank"
                color="inherit"
                underline="none"
              >
                <IconButton>
                  <FaFacebookF style={{ color: "royalblue" }} />
                </IconButton>{" "}
                Facebook
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href="https://youtube.com/mattengineeringequipments"
                target="_blank"
                color="inherit"
                underline="none"
              >
                <IconButton>
                  <FaYoutube style={{ color: "red" }} />
                </IconButton>{" "}
                Youtube
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href="https://twitter.com/mattenggsoln"
                target="_blank"
                color="inherit"
                underline="none"
              >
                <IconButton>
                  <FaTwitter style={{ color: "blue" }} />
                </IconButton>{" "}
                Twitter
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href="https://linkedin.com/company/mattengineeringsolutions"
                target="_blank"
                color="inherit"
                underline="none"
              >
                <IconButton>
                  <FaLinkedinIn style={{ color: "blue" }} />
                </IconButton>{" "}
                LinkedIn
              </MuiLink>
            </li>
            <li style={{ marginBottom: "10px" }}>
              <MuiLink
                href="https://instagram.com/mattengineering"
                target="_blank"
                color="inherit"
                underline="none"
              >
                <IconButton>
                  <FaInstagram style={{ color: "palevioletred" }} />
                </IconButton>{" "}
                Instagram
              </MuiLink>
            </li>
          </ul>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box
        sx={{
          textAlign: "center",
          mt: 4,
          py: 2,
          backgroundColor: "rgba(35, 65, 82, 1)",
          position: "relative",
        }}
      >
        <a
          href="https://www.mattengg.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Typography variant="body2" color="white" sx={{ mb: 0, fontSize: "0.875rem" }}>
            &copy; Matt Scholar Solutions 2024. All rights reserved.
          </Typography>
        </a>

        {/* Horizontal Line with Centered Details */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: 3,
            mb: 1,
            zIndex: 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              position: "absolute",
            }}
          />
          <Typography
            variant="body2"
            color="white"
            sx={{
              backgroundColor: "rgba(35, 65, 82, 1)",
              px: 2,
              zIndex: 1,
              opacity: "0.7",
              fontSize: "0.875rem",
            }}
          >
            Matt Scholar Soutions is owned and operated by "Matt Engineering Solutions."
          </Typography>
        </Box>

        {/* Address and Phone */}
        <Typography variant="body2" color="white" sx={{ mt: 1, opacity: "0.7", fontSize: "0.875rem" }}>
          Located at: 3rd floor, Pillars Gate, Vadasery, Kanyakumari Dist, Tamil Nadu 629001
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;